/**                        __
*       ________          | |
*      / React /,      __ | |__    __
*     /       //     / _ \| '_ \ / _ \
*    /_______//     | (_) | |_) |  __/
*   (_______(/       \___/|_.__/ \___|
*/

// Authors =========================================

// David Nuñez - dnunez@sanservices.hn
// Conary Hernandez - cjhernandez@sanservices.hn
// Willmer Barahona - wbarahona@sanservices.hn
// Luis Booth - lbooth@sanservices.hn

// Deps =========================================
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Header from './components/global/Header';
import sessionPerTab from './modules/sessionPerTab';
import '../sass/themes/sandals/master.scss';

sessionPerTab();

if (module.hot) {

  module.hot.accept();
}

// Main Menu
ReactDOM.render(
  <div id="obe-main-navigation-default" className="block">
    <Header brand={window._app.brand} />
  </div>, document.getElementById('rct-header'));



// WEBPACK FOOTER //
// ./js/master.js